export default __webpack_public_path__ + "static/media/check-dark.4eb6560e.svg";